module.exports = __webpack_public_path__ + "static/img/FINN-O’SULLIVAN.e096c22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/FINN-O’SULLIVAN.jpg
// module id = nu4f
// module chunks = 0